document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const header = document.querySelector('.section-header');

    let swiperInstance = null;
    function initOrDestroySwiper() {
        const mediaEl = document.querySelector('.media__exceution_swiper.swiper');
        if (!mediaEl) return;
        const isMobile = window.innerWidth < 750;
        if (isMobile && !swiperInstance) {
            const mediaConfig = {spaceBetween:0,slidesPerView:1.05,pagination:{el:'.swiper-pagination',type:'progressbar'} };
            swiperInstance = new Swiper(mediaEl, mediaConfig);
        }
        if (!isMobile && swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }
    }
    initOrDestroySwiper();
    window.addEventListener('resize', function(event) { initOrDestroySwiper() }, true);

    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
        const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
        if (!isIOS) {
            testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            testimonialConfig.freeMode = true;
        }
        new Swiper(testimonialEl, testimonialConfig);
    }

    const imageBriefEl = document.querySelector('.rainforest__image_briefswiper.swiper');
    if (imageBriefEl) {
        const imageBriefConfig = { spaceBetween: 18, slidesPerView: 'auto' };
        new Swiper(imageBriefEl, imageBriefConfig);
    } 

    const relatedItemsEl = document.querySelector('.related__items_swiper.swiper');
    if (relatedItemsEl) {
        const relatedItemsConfig = { spaceBetween: 18, slidesPerView: 'auto', grabCursor: true, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'} };
        if (!isIOS) {
            relatedItemsConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            relatedItemsConfig.freeMode = true;
        }
        new Swiper(relatedItemsEl, relatedItemsConfig);
    }  

    const swiperElements = document.querySelectorAll('.iconText_highPricePoint_swipe.swiper');
    if (swiperElements.length > 0) {
        swiperElements.forEach((elm, index) => {
            const config = { spaceBetween: 12, slidesPerView: 'auto', allowTouchMove: true, grabCursor: true, };
            if (!isIOS) { config.mousewheel = { forceToAxis: true, thresholdDelta: 35 }; config.freeMode = true; }
            new Swiper(elm, config);
        });
    }    

    const timelineItems = document.querySelectorAll('.timeline-item');
    const progressDots = document.querySelectorAll('.progress-dot');
    const progressBar = document.getElementById('progressBar');
    const progressContainer = document.querySelector('.progress-container');

    if (progressContainer || progressBar || timelineItems.length != 0 || progressDots.length != 0){
        function debounce(func, wait = 100) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), wait);
            };
        }
        function alignDotsToItems() {
            let cumulativeHeight = 0;
            timelineItems.forEach((item, index) => {
                const itemHeight = item.offsetHeight;
                const itemStyle = window.getComputedStyle(item);
                const marginBottom = parseFloat(itemStyle.marginBottom) || 0;
                if (progressDots[index]) {
                progressDots[index].style.top = `${cumulativeHeight}px`;
                }
                cumulativeHeight += itemHeight + marginBottom;
            });
            updateProgressBarHeight();
            adjustProgressContainerHeight();
        }
    
        function updateProgressBarHeight() {
            const activeDots = Array.from(progressDots).filter(dot => dot.classList.contains('active'));
            if (activeDots.length === 0) {
                progressBar.style.height = '0px';
                return;
            }
            const firstTop = parseFloat(progressDots[0].style.top) || 0;
            const lastActiveDot = activeDots[activeDots.length - 1];
            const lastTop = parseFloat(lastActiveDot.style.top) || 0;
            progressBar.style.top = `${firstTop}px`;
            progressBar.style.height = `${lastTop - firstTop}px`;
        }
    
        function setActiveDotByScroll() {
            const viewportCenter = window.innerHeight / 2;
            let activeIndex = 0;
            let minDistance = Infinity;
            timelineItems.forEach((item, index) => {
                const rect = item.getBoundingClientRect();
                const itemMiddle = rect.top + rect.height / 2;
                const distance = Math.abs(itemMiddle - viewportCenter);
                if (distance < minDistance) {
                minDistance = distance;
                activeIndex = index;
                }
            });
            timelineItems.forEach((item, index) => {
                const isActive = index <= activeIndex;
                item.classList.toggle('center-stage', index === activeIndex);
                progressDots[index]?.classList.toggle('active', isActive);
            });
            updateProgressBarHeight();
        }
    
        function adjustProgressContainerHeight() {
            const firstDotTop = progressDots[0].offsetTop;
            const lastDot = progressDots[progressDots.length - 1];
            const lastDotTop = lastDot.offsetTop;
            const lastDotHeight = lastDot.offsetHeight;
            const lastDotStyle = window.getComputedStyle(lastDot);
            const lastDotMarginBottom = parseFloat(lastDotStyle.marginBottom) || 0;
            const height = (lastDotTop + lastDotHeight + lastDotMarginBottom) - firstDotTop;
            progressContainer.style.height = `${height}px`;
        }
        const updateLayout = () => {
            alignDotsToItems();
            setActiveDotByScroll();
        };
        const debouncedUpdate = debounce(updateLayout, 100);
        window.addEventListener('scroll', debounce(setActiveDotByScroll, 50));
        window.addEventListener('resize', debouncedUpdate);
        requestAnimationFrame(() => {
            debouncedUpdate();
            setTimeout(debouncedUpdate, 150);
        });
        const observer = new ResizeObserver(debouncedUpdate);
        timelineItems.forEach(item => observer.observe(item));
        let tries = 0;
        const maxTries = 10;
        const retryLoop = () => {
            debouncedUpdate();
            if (++tries < maxTries) {
                setTimeout(retryLoop, 300);
            }
        };
        retryLoop();
    }

    class customVariantElements extends HTMLElement {
        connectedCallback() {
            this._variants    = null;
            this._product     = null;
            this._skioPlanIds = null;
            this._bindEvents();
        }

        get variants() {
            if (!this._variants) {
                const el = this.querySelector('script[type="application/json"][variant-based]');
                if (!el) {
                    return [];
                }
                try {
                    this._variants = JSON.parse(el.textContent);
                } catch (e) {
                    this._variants = [];
                }
            }
            return this._variants;
        }

        get product() {
            if (!this._product) {
                const el = this.querySelector('script[type="application/json"][data-product]');
                if (!el) {
                    return null;
                }
                try {
                    this._product = JSON.parse(el.textContent);
                } catch (e) {
                    this._product = null;
                }
            }
            return this._product;
        }

        get skioPlanIds() {
            if (!this._skioPlanIds) {
                this._skioPlanIds = new Set();
                const groups = this.product?.selling_plan_groups ?? [];
                groups.filter(g => g.app_id === 'SKIO').forEach(g => g.selling_plans.forEach(p => this._skioPlanIds.add(String(p.id))));
            }
            return this._skioPlanIds;
        }

        _resolveAllocation(variant) {
            const allocations = variant.selling_plan_allocations ?? [];
            let allocation = null;
            if (this.skioPlanIds.size > 0) {
                allocation = allocations.find(a => this.skioPlanIds.has(String(a.selling_plan_id)) );
            }
            if (!allocation) {
                allocation = allocations[0] ?? null;
            }
            return allocation;
        }

        _getPriceFromAllocation(allocation, variant) {
            if (allocation) {
                return {
                    price: allocation.price,
                    compare_at_price: allocation.compare_at_price || null,
                };
            }
            return {
                price: variant.price,
                compare_at_price: variant.compare_at_price || null,
            };
        }

        _bindEvents() {
            this.addEventListener('change', (e) => {
                const radio = e.target;
                if (radio.type !== 'radio') return;
                const label = radio.closest('label');
                const purchaseType = label?.getAttribute('purchasetypeproduct');
                if (purchaseType === 'additional-own-kit') {
                    document?.querySelectorAll(`[js-except-byob-option]`)?.forEach((el)=>{el?.classList?.add('hidden')});
                    document?.querySelectorAll(`[js-within-byob-option]`)?.forEach((el)=>{el?.classList?.remove('hidden')});
                    this._mediaUpdate(radio);
                    return;
                }
                if (purchaseType === 'product-options') {
                    this._handleVariantChange(radio.value);
                    this._mediaUpdate(radio);
                    return;
                }
            });
        }

        _mediaUpdate(mediaSelected) {
            document?.querySelector(`[js-byob--media]`)?.querySelector(`img`).setAttribute(`src`,mediaSelected.closest('label').dataset.mainMedia);
            document?.querySelector(`[js-byob--media]`)?.querySelector(`img`).setAttribute(`srcset`,mediaSelected.closest('label').dataset.mainMedia);
        }

        _handleVariantChange(selectedTitle) {
            const variant = this.variants.find(v => v.title === selectedTitle);
            if (!variant) {
                return;
            }
            const index = this.variants.findIndex(variant => variant.title === selectedTitle);
            const allocation = this._resolveAllocation(variant);
            const sellingPlanId = allocation?.selling_plan_id ?? '';
            const { price, compare_at_price } = this._getPriceFromAllocation(allocation, variant);
            const idInput          = this.querySelector('input[name="id"]');
            const sellingPlanInput = this.querySelector('input[name="selling_plan_id"]');
            if (idInput) idInput.value = variant.id;
            if (sellingPlanInput) sellingPlanInput.value = sellingPlanId;
            this._updatePrice(price, compare_at_price);
            document.querySelectorAll('[js-within-byob-option]').forEach(el => el.classList.add('hidden'));
            document.querySelectorAll('[js-except-byob-option]').forEach(el => {
                const elementIndex = el.getAttribute('data-index');
                if (elementIndex === null) {
                    el.classList.remove('hidden');
                    return;
                }
                if (elementIndex === String(index)) {
                    el.classList.remove('hidden'); 
                } else {
                    el.classList.add('hidden'); 
                }
            });
        }

        _updatePrice(price, compare_at_price) {
            const priceEl = document.querySelector('.tw_o__content__sale_price');
            const comparePriceEl = document.querySelector('.single_tw_o__content__cp_price');
            if (!priceEl) {
                return;
            }
            const formattedPrice = (price / 100).toFixed(2);
            const formattedCPrice = (compare_at_price / 100).toFixed(2);
            priceEl.textContent = `$${formattedPrice}`;
            comparePriceEl.textContent = `$${formattedCPrice}`;
            document.querySelector(`.buy__buttons_layout_container`).querySelector(`.product-form__submit`).querySelector(`.btn_txt_wp`).innerHTML = `Add to Cart — $${formattedPrice}&nbsp;<s>$${formattedCPrice}</s>`
        }        
    }
    customElements.define('cus-variants-single-two', customVariantElements);

    const getGuid = ()=> {
        let d = new Date().getTime();
        let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
        }); 
    }    

    if( document.querySelectorAll('[js-subscribe-processing-cart]').length > 0 ) {
        document.querySelectorAll('[js-subscribe-processing-cart]').forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                const Etarget = event.currentTarget;
                const productFormObject = Etarget.closest('.pdp__single_tw_o__content').querySelector(`.single_tw_o__content__form`).querySelector(`form`);
                const submitButton = Etarget.closest('.single_tw_o__content__bt__button').querySelector('button');
                submitButton.classList.add('loading');
                submitButton.disabled = true;
                let cartElement = document.querySelector("cart-drawer");
                if (cartElement) cartElement.enableLoading();
                let itemsToAdd = [];
                const isCustomProcess = Etarget.closest('[data-cart-process="true"]');
                if (isCustomProcess) {
                    const currentVariantId = productFormObject.querySelector('[name="id"]').value;
                    const bundleJson = JSON.parse(Etarget.closest(`.pdp__single_tw_o__content_nt`).querySelector(`.single_tw_o__content__form`).querySelector(`cus-variants-single-two`).querySelector('.bundle-data-json').textContent);
                    const data = bundleJson[currentVariantId];
                    if (data && data.ids) {
                        let uniqID = new Date().getTime().toString(),
                        bundleID = data.dynbox,
                        customImage = data.custom_image,
                        customTitle = data.custom_title,
                        customServing = data.custom_servings,
                        customPrice = data.custom_price,
                        customComparePrice = data.custom_compare_price,
                        customSubPrice = data.custom_sub_price,
                        customSubComparePrice = data.custom_sub_compare_price,                        
                        customQuantity = data.custom_quantity,
                        customQuantityGroup = data.qtys,
                        customSellingPlan = data.custom_selling_plan,
                        mainProperties = {
                            _dynamicBoxId: bundleID,
                            _custom_image:customImage,
                            _custom_title:customTitle,
                            _custom_serving:customServing,
                            _custom_price:customPrice,
                            _custom_compare_price:customComparePrice,
                            _custom_sub_price:customSubPrice,
                            _custom_sub_compare_price:customSubComparePrice,                            
                            _custom_quantity:customQuantity,
                            _custom_quantity_group:customQuantityGroup,
                            _customSellingPlanName:customSellingPlan
                        };         
                        const idArray = typeof data.ids === 'string' ? data.ids.split(',') : data.ids;
                        const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []);
                        const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []);
                        itemsToAdd = idArray.map((id, index) => {
                            const item = {
                                id: id.toString().trim(),
                                quantity: parseInt(qtyArray[index]) || 1,
                                properties:mainProperties
                            };
                            if (planArray[index] && planArray[index] !== "") {
                                item.selling_plan = parseInt(planArray[index]);
                            }
                            return item;
                        });
                    }
                }else{
                    let sellingId = productFormObject.querySelector('[name="selling_plan_id"]')?.value;
                    let targetId = productFormObject.querySelector('[name="id"]').value;
                    itemsToAdd.push({
                        id: targetId,
                        quantity: 1,
                        selling_plan: sellingId || null
                    });
                }
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then((response) => response.json())
                .then((parsedState) => {
                    if (cartElement) cartElement.renderContent(parsedState.sections);
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                    }
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                });
            });
        });
    }

    if( document.querySelectorAll('[js-onetime-processing-cart]').length > 0 ) {
        document.querySelectorAll('[js-onetime-processing-cart]').forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                const Etarget = event.currentTarget;
                const productFormObject = Etarget.closest('.pdp__single_tw_o__content').querySelector(`.single_tw_o__content__form`).querySelector(`form`);
                const submitButton = Etarget.closest('.single_tw_o__content__bt__button_ot').querySelector('button');
                submitButton.classList.add('loading');
                submitButton.disabled = true;
                let cartElement = document.querySelector("cart-drawer");
                if (cartElement) cartElement.enableLoading();
                let itemsToAdd = [];
                const isCustomProcessOneTime = Etarget.closest('[data-cart-process="true"]');
                if (isCustomProcessOneTime) {
                    const currentVariantIdOT = productFormObject.querySelector('[name="id"]').value;
                    const sectionContainerOT = Etarget.closest('[data-cart-process]');
                    const bundleJsonOT = JSON.parse(sectionContainerOT.querySelector('.bundle-data-json').textContent);
                    const dataOT = bundleJsonOT[currentVariantIdOT];
                    if (dataOT && dataOT.ids) {
                        let uniqID = new Date().getTime().toString(),
                        customImage = dataOT.custom_image,
                        customTitle = dataOT.custom_title,
                        customServing = dataOT.custom_servings,
                        customPrice = dataOT.custom_price,
                        customComparePrice = dataOT.custom_compare_price,
                        customSubPrice = dataOT.custom_sub_price,
                        customSubComparePrice = dataOT.custom_sub_compare_price,                        
                        customQuantity = dataOT.custom_quantity,
                        customQuantityGroup = dataOT.qtys,
                        mainProperties = {
                            _custom_image:customImage,
                            _custom_title:customTitle,
                            _custom_serving:customServing,
                            _custom_price:customPrice,
                            _custom_compare_price:customComparePrice,
                            _custom_sub_price:customSubPrice,
                            _custom_sub_compare_price:customSubComparePrice,                            
                            _custom_quantity:customQuantity,
                            _custom_quantity_group:customQuantityGroup
                        }; 
                        const idArrayOT = typeof dataOT.ids === 'string' ? dataOT.ids.split(',') : dataOT.ids;
                        const qtyArrayOT = typeof dataOT.qtys === 'string' ? dataOT.qtys.split(',') : (dataOT.qtys || []);
                        itemsToAdd = idArrayOT.map((id, index) => {
                            const item = {
                                id: id.toString().trim(),
                                quantity: parseInt(qtyArrayOT[index]) || 1,
                                properties:mainProperties
                            };
                            return item;
                        });
                    }
                }else{
                    let targetId = productFormObject.querySelector('[name="id"]').value;
                    itemsToAdd.push({
                        id: targetId,
                        quantity: 1
                    });
                }
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then((response) => response.json())
                .then((parsedState) => {
                    if (cartElement) cartElement.renderContent(parsedState.sections);
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                    }
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                });
            });
        });
    }
    
    if( document?.querySelectorAll('[js-widget-overview]').length > 0 ){
        document?.querySelectorAll('[js-widget-overview]').forEach((el)=>{
            el.addEventListener('click', (target) => {
                target.preventDefault();
                const offsetRvw = document?.querySelector('.custom__product__widget').offsetTop - header.clientHeight;
                window.scrollTo({
                    top: offsetRvw,
                    behavior: 'smooth'
                });
            })
        })
    }    
    
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
        document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
            })
        });
        document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
            })
        });  
    }

    if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
        document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
            elm.addEventListener('click',(target)=>{
                target.preventDefault();
                let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
                document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
                document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
                document.querySelector('.page-overlay').classList.add('is-visible');
                document.body.classList.add('overflow-hidden');
            })
        })   
    }
    
    class doctorDietitian extends HTMLElement{
        constructor(){
        super();
            this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
                elm.addEventListener('click',(target)=>{
                    target.preventDefault();
                    document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
                    document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
                    document.querySelector('.page-overlay').classList.remove('is-visible');
                    document.body.classList.remove('overflow-hidden');
                })
            })       
        }
    }
    window.customElements.define('cus-dietitian-widget',doctorDietitian);

    function isInViewport(elem) {
        const rect = elem.getBoundingClientRect();
        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    const stickyBar = document.querySelector('.rainforest__sticky_button_actions');
    const headerHeight = header ? header.clientHeight : 0;
    const addToCartElements = document.querySelectorAll('[js-subscribe-processing-cart]');
    const footerSections = document.querySelectorAll('.footer__main_wrapper');
    const recentlyViewedSections = document.querySelectorAll('[section="product-recently-viewed"]');
    
    function shouldHideSticky() {
        for (const el of [...addToCartElements, ...footerSections, ...recentlyViewedSections]) {
        if (el && isInViewport(el)) return true;
        }
        return false;
    }
    
    function handleStickyScroll() {
        const scrollY = window.scrollY;
        const triggerElement = document.querySelector('[js-subscribe-processing-cart]');
        if (!triggerElement || !stickyBar) return;
        const triggerOffset = triggerElement.offsetTop;
        if (scrollY > triggerOffset) {
            if (shouldHideSticky()) {
                stickyBar.classList.remove('stickyAddToCart');
                stickyBar.style.top = `-100%`;
            } else {
                stickyBar.classList.add('stickyAddToCart');
                stickyBar.style.top = `${headerHeight}px`;
            }
        } else {
            stickyBar.classList.remove('stickyAddToCart');
            stickyBar.style.top = `-100%`;
        }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    const stickyButton = document.querySelector('.rainforest__sticky_button_actions .rainforest__buttonScroll');
    const scrollTarget = document.querySelector('.single_tw_o__content__form');
    if (stickyButton && header && scrollTarget) {
        stickyButton.addEventListener('click', (e) => {
            e.preventDefault();
            const offset = scrollTarget.offsetTop - header.clientHeight;
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        });
    }
        
    const stickyFormContainer = document?.querySelector('.rainforest__sticky_button_actions');
    const productForm = document?.querySelector('.single_tw_o__content__form').querySelector(`cus-variants-single-two`);
    const cartDrawerSticky = document?.querySelector('cart-drawer');
    if (stickyFormContainer && productForm) {
        const submitBtn = stickyFormContainer.querySelector('.product-form__submit');
        submitBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            const variantId = productForm.querySelector('[name="id"]')?.value;
            const sellingPlanId = productForm.querySelector('[name="selling_plan_id"]')?.value;
            let itemsToAdd = [];
            const isCustomProcess = e.target.closest(`.shopify-section`).querySelector('[data-cart-process="true"]');
            if (isCustomProcess) {
                const bundleJson = JSON.parse(e.target.closest(`.shopify-section`).querySelector(`.pdp__single_tw_o__main`).querySelector(`.pdp__single_tw_o__content_nt`).querySelector(`.single_tw_o__content__form`).querySelector(`cus-variants-single-two`).querySelector('.bundle-data-json').textContent);
                const data = bundleJson[variantId];
                    if (data && data.ids) {
                        let uniqID = new Date().getTime().toString(),
                        bundleID = data.dynbox,
                        customImage = data.custom_image,
                        customTitle = data.custom_title,
                        customServing = data.custom_servings,
                        customPrice = data.custom_price,
                        customComparePrice = data.custom_compare_price,
                        customSubPrice = data.custom_sub_price,
                        customSubComparePrice = data.custom_sub_compare_price,                        
                        customQuantity = data.custom_quantity,
                        customQuantityGroup = data.qtys,
                        customSellingPlan = data.custom_selling_plan,
                        mainProperties = {
                            _dynamicBoxId: bundleID,
                            _custom_image:customImage,
                            _custom_title:customTitle,
                            _custom_serving:customServing,
                            _custom_price:customPrice,
                            _custom_compare_price:customComparePrice,
                            _custom_sub_price:customSubPrice,
                            _custom_sub_compare_price:customSubComparePrice,                            
                            _custom_quantity:customQuantity,
                            _custom_quantity_group:customQuantityGroup,
                            _customSellingPlanName:customSellingPlan
                        };         
                        const idArray = typeof data.ids === 'string' ? data.ids.split(',') : data.ids;
                        const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []);
                        const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []);
                        itemsToAdd = idArray.map((id, index) => {
                            const item = {
                                id: id.toString().trim(),
                                quantity: parseInt(qtyArray[index]) || 1,
                                properties:mainProperties
                            };
                            if (planArray[index] && planArray[index] !== "") {
                                item.selling_plan = parseInt(planArray[index]);
                            }
                            return item;
                        });
                    }
            }else{
                itemsToAdd.push({
                    id: variantId,
                    quantity: 1,
                    selling_plan: sellingPlanId || null
                });
            }

            const productShouldBe = {
                items: itemsToAdd,
                sections: cartDrawerSticky?.getSectionsToRender()?.map(section => section.section) || [],
                sections_url: window.location.pathname
            };            
            
            submitBtn.classList.add('loading');
            submitBtn.disabled = true;
            cartDrawerSticky?.enableLoading();
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(productShouldBe),
                credentials: 'same-origin'
            })
            .then(response => response.json())
            .then(parsedState => {
                cartDrawerSticky?.renderContent(parsedState.sections);
            })
            .catch(console.error)
            .finally(() => {
                cartDrawerSticky?.disableLoading();
                cartDrawerSticky?.open();
                submitBtn.classList.remove('loading');
                submitBtn.disabled = false;
            });
        });
    }

    if( document?.querySelectorAll('[js-widget-overview]').length > 0 ){
        document?.querySelectorAll('[js-widget-overview]').forEach((el)=>{
            el.addEventListener('click', (target) => {
                target.preventDefault();
                const offsetRvw = document?.querySelector('.custom__product__widget').offsetTop - header.clientHeight - stickyFormContainer.clientHeight;
                window.scrollTo({
                top: offsetRvw,
                behavior: 'smooth'
                });
            })
        })
    }  

    function setupMarquee({ contentId, containerSelector, speed = 0.5 }) {
        const scrollingContent = document.getElementById(contentId);
        if (!scrollingContent) {
            console.warn(`Marquee setup failed: Element with ID "${contentId}" not found.`);
            return;
        }
        const container = document.querySelector(containerSelector);
        if (!container) {
            console.warn(`Marquee setup failed: Container with selector "${containerSelector}" not found.`);
            return;
        }
        scrollingContent.innerHTML += scrollingContent.innerHTML;
        let x = 0;
        let isPaused = false;
        function animate() {
        if (!isPaused) {
            x -= speed;
            if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
            x = 0;
            }
            scrollingContent.style.transform = `translateX(${x}px)`;
        }
        requestAnimationFrame(animate);
        }
        container.addEventListener("mouseenter", () => { isPaused = true; });
        container.addEventListener("mouseleave", () => { isPaused = false; });
        animate();
    }
    setupMarquee({ contentId: "marqueeContent", containerSelector: ".scrolling__card_content", speed: 0.4 });
    setupMarquee({ contentId: "scrollingContent", containerSelector: ".squeeze_scroller_main", speed: 0.5 }); 
    

})